import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

// Wraps protected routes. If auth is still initialising, renders a dim loading
// shell to avoid flashing the login page while the token is being validated.
export default function ProtectedRoute({ children }) {
  const { user, initialising } = useAuth();
  const loc = useLocation();

  if (initialising || user === null) {
    return (
      <div className="min-h-screen grid place-items-center bg-slate-50">
        <div className="text-sm text-slate-500">Loading Flexspace…</div>
      </div>
    );
  }

  if (user === false) {
    // Preserve where the user was heading so we can bounce them back after login.
    return <Navigate to="/login" replace state={{ from: loc.pathname + loc.search }} />;
  }

  return children;
}
